module.exports = __webpack_public_path__ + "static/media/banner.3b98daa2.jpg";